import i18n from 'i18next';
import { UI_DATE_LOWER_FORMAT } from 'globalconfig/constants/static';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { pageUrls } from 'globalconfig/constants/keys';

export const subTabFields = [
  {
    type: 'text',
    value: '',
    field: 'driver_name',
    placeholder: i18n.t('common.driver'),
    label: i18n.t('common.driver'),
  },
  {
    type: 'date',
    value: '',
    field: 'dateFrom',
    placeholder: UI_DATE_LOWER_FORMAT,
    label: i18n.t('common.dateFrom'),
    isTimeNeeded: false,
    isClearable: true,
  },
  {
    type: 'date',
    value: '',
    field: 'dateTo',
    placeholder: UI_DATE_LOWER_FORMAT,
    label: i18n.t('common.dateTo'),
    isTimeNeeded: false,
    minValue: 'dateFrom',
  },
];

export const tabValuesComponentFields = [
  {
    type: 'text',
    value: '',
    field: 'driver_name',
    placeholder: i18n.t('common.driver'),
    label: i18n.t('common.driver'),
  },
  {
    type: 'date',
    value: '',
    field: 'dateFrom',
    placeholder: UI_DATE_LOWER_FORMAT,
    label: i18n.t('common.dateFrom'),
    isTimeNeeded: false,
    isClearable: true,
  },
  {
    type: 'date',
    value: '',
    field: 'dateTo',
    placeholder: UI_DATE_LOWER_FORMAT,
    label: i18n.t('common.dateTo'),
    isTimeNeeded: false,
    minValue: 'dateFrom',
  },
];

export const tenantMapping = {
  no_driver: {
    [SERVICE_PROVIDERS.SPIREON]: [],
    default: [
      {
        name: i18n.t('logs.addLogHeader'),
        value: null,
        url: pageUrls.logsAdd,
      },
      {
        name: i18n.t('logs.archiveLogsHeader'),
        value: null,
        url: pageUrls.archiveLogsList,
      },
    ],
  },
  [SERVICE_PROVIDERS.SPIREON]: [
    {
      name: i18n.t('leftMenu.DOTAudit'),
      value: null,
      url: pageUrls.fmcsaLogs,
    },
  ],
  default: [],
};
